import * as React from 'react';

import { useAppDispatch, useAppSelector } from '../../../app/hooks';

import { useUtilityContext } from '../../../utility-provider';
import { encryptQueryParam, decryptQueryParam } from '../../../utility/util';
import { planAreaSearchById } from "../../../api/DataManage";
import { setReceptionBook } from '../../../features/receptionBookSlice';

import {
    Box,
    Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUserContext } from '../../../user-provider';
import Computer from '@mui/icons-material/Computer';
import PhoneIphone from '@mui/icons-material/PhoneIphone';
import ResearchBranchModal from '../ResearchBranchModal';
import ConfirmDialog from '../../common/ConfirmDialog';
import { hasScroll } from "../../common/Scroll";
import { userLogging } from '../../../utility/firestore';
import { LOCAL_CONSTANT } from '../../common/Const';

export interface resultProps {
    props: {
    }
}

const Planareamenu: React.FC<resultProps> = ({ props }) => {
    const utilityCtx = useUtilityContext();
    const user = useUserContext();
    const [userData, setUserData] = React.useState<any>({});
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    //URLパラメータ
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [planArea, setPlanArea] = React.useState<any>([]);
    // 受付簿
    const objReceptionBook = useAppSelector((state) => state.receptionBook.select);
    //モーダル開閉フラグ(調査書枝選択画面)
    const [researchPlanAreaId, setResearchPlanAreaId] = React.useState<string>("");
    const [researchBranchOpen, setResearchBranchOpen] = React.useState(false);
    // ボタン無効化制御 trueが非活性 falseが活性
    const [buttonsDisabled, setButtonsDisabled] = React.useState(true);
    // ダイアログ開閉フラグ
    const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);

    //URLパラメータ取得
    React.useEffect(() => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        hasScroll();
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            if (res[0] && res[0].trim() !== '') {
                setPlanAreaId(res[0]);
            } else {
                // planAreaIdが存在しない場合はダイアログを表示
                setErrorDialogOpen(true);
            }
        }).catch((e:any) => {
            console.log(e);
            // 復号化エラーの場合もダイアログを表示
            setErrorDialogOpen(true);
        }).finally(() => {
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    },[]);

    //ユーザー取得タイミングによる画面制御
    React.useEffect(() => {
        if (JSON.parse(user.userData || 'null') !== null) {
            setUserData(JSON.parse(user.userData));
        }
    }, [user]);

    React.useEffect(() => {
        if (planAreaId) {
            getPlanArea(planAreaId);
            document.title = `立地調査${planAreaId}`;
        }
    }, [planAreaId]);

    // ボタン状態制御
    React.useEffect(() => {
        const hasValidData = Boolean(planAreaId);
        setButtonsDisabled(!hasValidData);
    }, [planAreaId]);

    // 画面表示 userLogging
    React.useEffect(() => {
        if (planAreaId && user.userData) {
            const decryptedUrl = window.location.pathname + `?planAreaId=${planAreaId}&referrer=rview`;
            const encryptedUrl = window.location.pathname + window.location.search;
            
            userLogging(
                LOCAL_CONSTANT.FUNCTION_NAME.PLANAREAMENU_DISPLAY,
                {
                    decrypted_url: decryptedUrl,
                    encrypted_url: encryptedUrl
                },
                user
            );
        }
    }, [planAreaId, user]);

    const getPlanArea = (planAreaId: string) => {
        if (Object.keys(userData).length > 0) {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner()
            }
            // 候補地呼び出し
            callApi('planArea')
                .then((res: any) => {
                    setPlanArea(res[0])
                    dispatch(setReceptionBook({
                        ...objReceptionBook,
                        plan_area_id: res[0]["plan_area_id"],
                        plan_area_name: res[0]["plan_area_name"]
                    }))
                }).catch((e) => {
                    console.log(e);
                    setErrorDialogOpen(true);
                }).finally(() => {
                    if (utilityCtx.hideSpinner) {
                        utilityCtx.hideSpinner();
                    }
                })
        }
    }

    const callApi = async (target: string) => {
        if (target === 'planArea') {
            const jsonUserData = JSON.parse(user.userData);
            let manageCitiesFlg = true
            if (jsonUserData.administrator_flag === "1" || jsonUserData.manage_cities?.includes("ALL")) {
                manageCitiesFlg = false;
            }
            const manage_steps = ['0', '99']
            let stepCnt = jsonUserData.manage_steps.filter(
                (val: any) => manage_steps.includes(val) === false
            );
            let managePlansOutsideCities = jsonUserData.manage_plans_outside_cities;
            if (!managePlansOutsideCities.includes("")) {
                managePlansOutsideCities.push("");
            }
            return await planAreaSearchById({
                mode: "planAreaSearchById",
                id: planAreaId,
                manageCitiesFlg: manageCitiesFlg,
                manageCities: jsonUserData.manage_cities.join(','),
                manageStep: stepCnt.join(','),
                managePlansOutsideCities: managePlansOutsideCities.join(','),
            })
        }
    }

    //モーダルオープン(調査書枝選択画面)
    const handleResearchBranchOpen = () => {
        setResearchPlanAreaId(planAreaId!)
        setResearchBranchOpen(true);
    };

    const handleMove = (location: string) => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner()
        }
        // URLパラメータ暗号化
        const param = `planAreaId=${planAreaId}&referrer=rview`;
        encryptQueryParam(param).then((res) => {
            const url = location + res;
            navigate(url);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    return (
        <>
            <Box sx={{ margin: '0 auto', padding: '10px' }}>
                <Box sx={{ margin: '10px 0', textAlign: 'center' }}>立地調査</Box>
                <Box sx={{ margin: '10px 0', display: 'flex', justifyContent: 'center' }}>{planAreaId}：{planArea.plan_area_name}</Box>
                <Box sx={{ margin: '20px 0', textAlign: 'center' }}>
                    <Box>
                        <Button
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success"
                            disabled={buttonsDisabled}
                            onClick={handleResearchBranchOpen} 
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <Computer />
                            </Box>調査書
                        </Button>
                    </Box>
                    <Box>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success"
                            disabled={buttonsDisabled}
                            onClick={()=>{handleMove("/Photo/upload?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <PhoneIphone />
                            </Box>写真登録
                        </Button>
                    </Box>
                    <Box>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px' }} 
                            variant="contained" 
                            color="success"
                            disabled={buttonsDisabled}
                            onClick={()=>{handleMove("/TrafficVolume/select?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                                <PhoneIphone />
                            </Box>通行量調査
                        </Button>
                    </Box>
                    <Box sx={{
                        '& .MuiButton-root:hover': { backgroundColor: '#205766' }
                    }}>
                        <Button 
                            sx={{ margin: '10px 0', minWidth: '200px', width: '200px', backgroundColor: '#31859c' }} 
                            variant="contained" 
                            color="success"
                            disabled={buttonsDisabled}
                            onClick={()=>{handleMove("/TrafficConfirmationScreen?")}}
                        >
                            <Box 
                                sx={{ position: 'absolute', left: '0', margin: '6px 0 0 10px' }}>
                            </Box>計測結果確認
                        </Button>
                    </Box>
                </Box>
                <ResearchBranchModal props={{ modalOpen: researchBranchOpen, setModalOpen: setResearchBranchOpen, planAreaId: researchPlanAreaId }} />
                <ConfirmDialog props={{
                    open: errorDialogOpen,
                    handleModal: setErrorDialogOpen,
                    onCancel: () => {},
                    onExecution: () => {},
                    onCancelRegist: () => {},
                    mode: "",
                    body: LOCAL_CONSTANT.ERROR_MESSAGE.PLAN_AREA_ID_NOT_FOUND,
                    confirmCancel: "",
                    confirmOk: "",
                    confirmCancelRegist: "",
                }} />
            </Box>
        </>
    )
}

export default Planareamenu;
